import { inject } from '@angular/core'

import { Actions, createEffect, ofType } from '@ngrx/effects'

import { map } from 'rxjs'

import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'

import { createDataModelEffects } from './data-model.effects'

import { DataModelApiService } from '../../api/data-model.api'
import { ReusableFunctionDataModelEntityToUIEntity } from '../../entities/data-model.entity'
import { ReusableFunctionDataModelActions } from '../actions/reusable-functions.data-model.actions'

const reusableFunctionDataModelBasicEffects = createDataModelEffects(
  ApplicationResourceType.ReusableFunction,
  {
    load: ReusableFunctionDataModelActions.loadEntities,
    loadSuccess: ReusableFunctionDataModelActions.loadEntitiesSuccess,
    loadFailure: ReusableFunctionDataModelActions.loadEntitiesFailure,
    add: ReusableFunctionDataModelActions.addEntity,
    addSuccess: ReusableFunctionDataModelActions.addEntitySuccess,
    addFailure: ReusableFunctionDataModelActions.addEntityFailure,
    edit: ReusableFunctionDataModelActions.editEntity,
    editSuccess: ReusableFunctionDataModelActions.editEntitySuccess,
    editFailure: ReusableFunctionDataModelActions.editEntityFailure,
    addAttribute: ReusableFunctionDataModelActions.addAttribute,
    addAttributeSuccess: ReusableFunctionDataModelActions.addAttributeSuccess,
    addAttributeFailure: ReusableFunctionDataModelActions.addAttributeFailure,
    editAttribute: ReusableFunctionDataModelActions.editAttribute,
    editAttributeSuccess: ReusableFunctionDataModelActions.editAttributeSuccess,
    editAttributeFailure: ReusableFunctionDataModelActions.editAttributeFailure,
    requestDeleteEntity: ReusableFunctionDataModelActions.deleteEntityRequested,
    deleteEntity: ReusableFunctionDataModelActions.deleteEntity,
    deleteEntitySuccess: ReusableFunctionDataModelActions.deleteEntitySuccess,
    deleteEntityFailure: ReusableFunctionDataModelActions.deleteEntityFailure,
    requestDeleteAttribute: ReusableFunctionDataModelActions.deleteAttributeRequested,
    deleteAttribute: ReusableFunctionDataModelActions.deleteAttribute,
    deleteAttributeSuccess: ReusableFunctionDataModelActions.deleteAttributeSuccess,
    deleteAttributeFailure: ReusableFunctionDataModelActions.deleteAttributeFailure,
    resetErrors: ReusableFunctionDataModelActions.resetErrors,
    resetErrorsSuccess: ReusableFunctionDataModelActions.resetErrorsSuccess,
    updateAttributeValidators: ReusableFunctionDataModelActions.updateAttributeValidators,
    updateAttributeValidatorsSuccess:
      ReusableFunctionDataModelActions.updateAttributeValidatorsSuccess,
    updateAttributeValidatorsFailure:
      ReusableFunctionDataModelActions.updateAttributeValidatorsFailure,
  },
  DataModelApiService
)

export const reusableFunctionLoadEntities$ = reusableFunctionDataModelBasicEffects.loadEntities$
export const reusableFunctionAddEntity$ = reusableFunctionDataModelBasicEffects.addEntity$
export const reusableFunctionEditEntity$ = reusableFunctionDataModelBasicEffects.editEntity$
export const reusableFunctionAddAttribute$ = reusableFunctionDataModelBasicEffects.addAttribute$
export const reusableFunctionEditAttribute$ = reusableFunctionDataModelBasicEffects.editAttribute$
export const reusableFunctionSetNewEntityAsAttribute$ =
  reusableFunctionDataModelBasicEffects.setNewEntityAsAttribute$
export const reusableFunctionStartDeleteEntity$ =
  reusableFunctionDataModelBasicEffects.startDeleteEntity$
export const reusableFunctionDeleteEntity$ = reusableFunctionDataModelBasicEffects.deleteEntity$
export const reusableFunctionStartDeleteAttribute$ =
  reusableFunctionDataModelBasicEffects.startDeleteAttribute$
export const reusableFunctionDeleteAttribute$ =
  reusableFunctionDataModelBasicEffects.deleteAttribute$
export const reusableFunctionResetErrors$ = reusableFunctionDataModelBasicEffects.resetErrors$
export const reusableFunctionUpdateAttributeValidators$ =
  reusableFunctionDataModelBasicEffects.updateAttributeValidators$

export const updateDataModelFromParamsUpdate$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(ReusableFunctionDataModelActions.updateEntitiesFromParamsUpdate),
      map(({ resourceId, entities }) =>
        ReusableFunctionDataModelActions.loadEntitiesSuccess({
          resourceId,
          entities: entities.map((e) => ReusableFunctionDataModelEntityToUIEntity(e)),
        })
      )
    ),
  { functional: true }
)
